export const userRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/Welcome.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/report/:id",
    name: "report",
    component: () => import("@/views/home/ReportPage.vue"),
    meta: {
      hideLayout: true,
      i18Alias: "layout",
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboard/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/notifications/:id",
    name: "notification-detail",
    component: () => import("@/views/dashboard/detail/NotificationDetail.vue"),
    meta: { requiresAuth: true, i18Alias: "layout" },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("@/views/dashboard/Notifications.vue"),
    meta: { requiresAuth: true, i18Alias: "layout" },
  },
  {
    path: "/billing",
    name: "billing",
    redirect: "/billing/orders",
    meta: { requiresAuth: true },
    children: [
      // {
      //   path: "/billing/overview",
      //   name: "billing-overview",
      //   component: () => import("@/views/dashboard/billing/Overview.vue"),
      //   meta: { requiresAuth: true, i18Alias: "billing" },
      // },
      {
        path: "/billing/orders",
        name: "billing-orders",
        component: () => import("@/views/dashboard/billing/Orders.vue"),
        meta: { i18Alias: "billing" },
      },
      {
        path: "/billing/invoices",
        name: "billing-invoices",
        component: () => import("@/views/dashboard/billing/Invoices.vue"),
        meta: { i18Alias: "billing" },
      },
      // {
      //   path: "/billing/subscription",
      //   name: "billing-subscription",
      //   component: () => import("@/views/dashboard/billing/Subscription.vue"),
      //   meta: { requiresAuth: true, i18Alias: "billing" },
      // },
    ],
  },
  {
    path: "/invite",
    name: "invite",
    component: () => import("@/views/dashboard/Invite.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/usage",
    name: "usage",
    component: () => import("@/views/dashboard/Usage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/views/dashboard/ReportHistory.vue"),
  },
  {
    path: "/upgrade",
    name: "upgrade",
    component: () => import("@/views/dashboard/upgrade/Entry.vue"),
    meta: { requiresAuth: true, i18Alias: "pricing" },
  },
  {
    path: "/pay-per-use",
    name: "pay-per-use",
    component: () => import("@/views/dashboard/upgrade/PayPerUse.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/dashboard/News.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment",
    name: "payment",
    component: () => import("@/views/dashboard/upgrade/PaymentResult.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-result",
    name: "payment-result",
    component: () => import("@/views/home/PaymentSuccess.vue"),
    meta: { hideLayout: true },
  },
  {
    path: "/pay/paddle",
    name: "payPaddle",
    component: () => import("@/views/dashboard/upgrade/PayPaddle.vue"),
    meta: { requiresAuth: true, hideLayout: true, i18Alias: "pay" },
  },
  {
    path: "/tickets",
    name: "tickets",
    component: () => import("@/views/dashboard/Tickets.vue"),
    // meta: { requiresAuth: true },
  },
  {
    path: "/tickets/:id",
    name: "ticket-detail",
    component: () => import("@/views/dashboard/detail/TicketDetail.vue"),
    meta: { requiresAuth: true, i18Alias: "tickets" },
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/setting/Setting.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/Login.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/verify-email",
    name: "verifyEmail",
    component: () => import("@/views/login/VerifyEmail.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/request-reset-password",
    name: "requestResetPassword",
    component: () => import("@/views/login/RequestResetPassword.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/Login.vue"),
    meta: {
      hideFooter: true,
    },
    beforeEnter: (to, from, next) => {
      // 将模式设置为注册
      to.query.mode = "sign_up";
      next();
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/views/home/Legal.vue"),
    props: { type: "privacy" },
    meta: {
      i18Alias: "legal",
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/views/home/Legal.vue"),
    props: { type: "terms" },
    meta: {
      i18Alias: "legal",
    },
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("@/views/home/PricingPage.vue"),
  },
  {
    path: "/pay-as-you-go",
    name: "pay-as-you-go",
    component: () => import("@/views/pricing/PayAsYouGo.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("@/views/blog/Blog.vue"),
  },
  {
    path: "/blog/:lang",
    name: "blog-lang",
    component: () => import("@/views/blog/Blog.vue"),
  },
  {
    path: "/blog/:slug",
    name: "blog-detail",
    component: () => import("@/views/blog/BlogDetail.vue"),
  },
  {
    path: "/blog/:lang/:slug",
    name: "blog-detail",
    component: () => import("@/views/blog/BlogDetail.vue"),
    meta: {
      i18Alias: "blog",
    },
  },
  {
    path: "/whitepaper",
    name: "whitepaper",
    component: () => import("@/views/home/Whitepaper.vue"),
  },
  {
    path: "/shared-report/:token",
    name: "shared-report",
    component: () => import("@/views/home/SharedReport.vue"),
    meta: {
      hideLayout: true,
      i18Alias: "reports",
    },
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("@/views/home/FAQ.vue"),
    meta: {
      i18Alias: "common",
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/home/About.vue"),
  },
  {
    path: "/unsubscribe",
    name: "unsubscribe",
    component: () => import("@/views/home/Unsubscribe.vue"),
    meta: {
      hideLayout: true,
    },
  },
  {
    path: "/auth/:type",
    name: "auth",
    component: () => import("@/views/login/Auth.vue"),
    meta: {
      hideLayout: true,
      i18Alias: "layout",
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () => import("@/views/login/ResetPassword.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/quick-check",
    name: "quickCheck",
    component: () => import("@/views/home/QuickCheck.vue"),
    meta: {
      hideLayout: true,
    },
  },
  {
    path: "/tracking",
    name: "tracking",
    component: () => import("@/views/home/trackedPage.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/views/home/NotFound.vue"),
    meta: {
      hideFooter: true,
      i18Alias: "layout",
    },
  },
];
